var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"d":"M38 26H26v12h-4V26H10v-4h12V10h4v12h12v4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }